module.exports = __webpack_public_path__ + "img/20180123_201347-min.b585f2f5.jpg";